// Template213: Osaka - Día 3 USJ Harry Potter y más (Page10)
// Cómo llegar USJ, Harry Potter, Hogwarts, Otras zonas, Desfiles, footer app.

import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import SabiasQue from "../SabiasQue";

const Template213 = ({
	backgroundColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const headerText = page?.texts?.[0]?.content;
	const llegarTitle = page?.texts?.[1]?.content;
	const llegarList = page?.texts?.[2]?.content;
	const hpTitle = page?.texts?.[3]?.content;
	const hpBody = page?.texts?.[4]?.content;
	const butterbeerTip = page?.texts?.[5]?.content;
	const hogwartsTitle = page?.texts?.[6]?.content;
	const hogwartsBody = page?.texts?.[7]?.content;
	const otrasTitle = page?.texts?.[8]?.content;
	const otrasBody = page?.texts?.[9]?.content;
	const paradeTitle = page?.texts?.[10]?.content;
	const paradeBody = page?.texts?.[11]?.content;
	const footerApp = page?.texts?.[12]?.content;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found?.src) return found.src;
		}
		return undefined;
	};

	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const hpImage = getImageSrc("hp");
	const hogwartsImage = getImageSrc("hogwarts");
	const butterbeerImage = getImageSrc("butterbeer");
	const hollywoodImage = getImageSrc("hollywood");
	const paradeImage = getImageSrc("parade");
	const logoImage = getCanvasImageUrl("logo");

	const sabiasQue = Array.isArray(page?.data?.sabiasQue)
		? page.data.sabiasQue
		: [];

	const actualHeaderColor = headerBackgroundColor || "#1F4E3D";

	const estiloH3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 14,
		fontWeight: 700,
		textTransform: "uppercase",
		margin: 0,
	};

	const estiloP = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		color: "#444",
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 1,
				}}
			>
				{isSmallScreen && page?.data?.headerMobile
					? page.data.headerMobile
					: headerText}
				{logoImage && (
					<Box
						component="img"
						src={logoImage}
						alt="logo"
						sx={{
							width: isSmallScreen ? 66 : 80,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</Box>

			<Box
				data-block-id="text-1"
				sx={{
					padding: "10px 12px",
					flex: 1,
					display: "flex",
					flexDirection: "column",
					gap: 2,
				}}
			>
				{(llegarTitle || llegarList) && (
					<Box
						data-block-id="text-2"
						sx={{
							backgroundColor: "#d1e6de",
							border: "3px solid #1F4E3D",
							borderRadius: "12px",
							padding: "16px 20px",
							fontSize: 12,
							color: "#333",
						}}
					>
						{llegarTitle && (
							<Box
								component="h4"
								sx={{
									margin: 0,
									marginBottom: 1,
									fontSize: 13,
									fontWeight: 700,
									color: "#1F4E3D",
									textTransform: "uppercase",
								}}
							>
								{llegarTitle}
							</Box>
						)}
						{llegarList && (
							<Box
								component="ul"
								sx={{ paddingLeft: 2.5, margin: 0, lineHeight: 1.5 }}
								dangerouslySetInnerHTML={{ __html: llegarList }}
							/>
						)}
					</Box>
				)}

				{/* Harry Potter */}
				<Box data-block-id="text-3" sx={{ display: "flex", gap: 2, alignItems: "flex-start" }}>
					{hpImage && (
						<Box
							component="img"
							src={hpImage}
							alt=""
							sx={{
								width: "40%",
								height: 110,
								borderRadius: "12px",
								objectFit: "cover",
							}}
						/>
					)}
					<Box sx={{ width: "60%" }}>
						{hpTitle && (
							<Box component="h3" sx={estiloH3}>
								{hpTitle}
							</Box>
						)}
						{hpBody && (
							<Box component="p" sx={estiloP}>
								{hpBody}
							</Box>
						)}
					</Box>
				</Box>

				{/* Hogwarts */}
				<Box
					data-block-id="text-4"
					sx={{
						flex: 1,
						display: "flex",
						flexDirection: "column",
						gap: 2,
						position: "relative",
					}}
				>
					{butterbeerImage && (
						<Box
							component="img"
							src={butterbeerImage}
							alt=""
							sx={{ width: 95, position: "absolute", bottom: -40, right: 0 }}
						/>
					)}
					{butterbeerTip && (
						<Box
							sx={{
								position: "absolute",
								bottom: -20,
								right: 80,
								backgroundColor: "#fff8db",
								border: "2px solid #f5c400",
								borderRadius: "16px 16px 0px 16px",
								padding: "10px 12px",
								fontSize: 11,
								color: "#444",
								boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
								maxWidth: 160,
							}}
							dangerouslySetInnerHTML={{ __html: butterbeerTip }}
						/>
					)}
					<Box sx={{ display: "flex", gap: 2, alignItems: "flex-start" }}>
						{hogwartsImage && (
							<Box
								component="img"
								src={hogwartsImage}
								alt=""
								sx={{
									width: "40%",
									height: 110,
									borderRadius: "12px",
									objectFit: "cover",
								}}
							/>
						)}
						<Box sx={{ width: "60%" }}>
							{hogwartsTitle && (
								<Box component="h3" sx={estiloH3}>
									{hogwartsTitle}
								</Box>
							)}
							{hogwartsBody && (
								<Box component="p" sx={estiloP}>
									{hogwartsBody}
								</Box>
							)}
						</Box>
					</Box>
				</Box>

				{/* Otras zonas */}
				<Box
					data-block-id="text-5"
					sx={{
						display: "flex",
						gap: 2,
						alignItems: "flex-start",
						position: "relative",
						marginTop: 2,
					}}
				>
					{sabiasQue.length > 0 && (
						<>
							<Box sx={{ position: "absolute", top: -20, left: "30%" }}>
								<SabiasQue
									icono={sabiasQue[0]?.icono ?? "🎢"}
									texto={sabiasQue[0]?.texto ?? ""}
								/>
							</Box>
							{sabiasQue[1] && (
								<Box sx={{ position: "absolute", top: 50, left: "30%" }}>
									<SabiasQue
										icono={sabiasQue[1]?.icono ?? "🎬"}
										texto={sabiasQue[1]?.texto ?? ""}
									/>
								</Box>
							)}
						</>
					)}
					{hollywoodImage && (
						<Box
							component="img"
							src={hollywoodImage}
							alt=""
							sx={{
								width: "40%",
								height: 110,
								borderRadius: "12px",
								objectFit: "cover",
							}}
						/>
					)}
					<Box sx={{ width: "60%" }}>
						{otrasTitle && (
							<Box component="h3" sx={estiloH3}>
								{otrasTitle}
							</Box>
						)}
						{otrasBody && (
							<Box component="p" sx={estiloP}>
								{otrasBody}
							</Box>
						)}
					</Box>
				</Box>

				{/* Desfiles */}
				<Box data-block-id="text-6" sx={{ display: "flex", gap: 2, alignItems: "flex-start" }}>
					{paradeImage && (
						<Box
							component="img"
							src={paradeImage}
							alt=""
							sx={{
								width: "40%",
								height: 110,
								borderRadius: "12px",
								objectFit: "cover",
							}}
						/>
					)}
					<Box sx={{ width: "60%" }}>
						{paradeTitle && (
							<Box component="h3" sx={estiloH3}>
								{paradeTitle}
							</Box>
						)}
						{paradeBody && (
							<Box component="p" sx={estiloP}>
								{paradeBody}
							</Box>
						)}
					</Box>
				</Box>
			</Box>

			{footerApp && (
				<Box
					data-block-id="text-7"
					sx={{
						padding: "10px 12px",
						position: "relative",
						marginTop: isSmallScreen ? 0 : "-10px",
					}}
				>
					<Box
						sx={{
							backgroundColor: "#d1e6de",
							border: "2px solid #1F4E3D",
							borderRadius: "12px",
							padding: "8px 14px",
							fontSize: "12px",
							color: "#444",
							textAlign: "center",
						}}
					>
						{footerApp}
					</Box>
				</Box>
			)}
		</Box>
	);
};

Template213.thumbnail = "/images/template-1.png";
export default Template213;
